// Vendor
import * as React from 'react';
import { inject } from 'mobx-react';
// Bernie
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ContextStore } from 'bernie-core';
import { MultiItemStore } from 'stores/multi-item-store';

interface TargetableLinkProps {
  context?: ContextStore;
  multiItem?: MultiItemStore;
  children?: any;
}

export const TargetableLink: React.FunctionComponent<TargetableLinkProps> = inject('context', 'multiItem')(
  ({ context, multiItem, children }) => {
    const deviceInformation = context && context.deviceInformation;
    const multiItemShoppingPath = multiItem && multiItem.isPackageShoppingPath();

    if (multiItemShoppingPath) {
      return React.cloneElement(children, {
        ...children.props,
        target: deviceInformation && (deviceInformation.mobile || deviceInformation.tablet) ? '_self' : '_blank'
      });
    }

    if (deviceInformation && !deviceInformation.tablet && !deviceInformation.mobile) {
      return (
        <AbacusExperiment name="Shopping_PWA_POC_Enable_Hotel_Infosite">
          <AbacusControl>
            {React.cloneElement(children, {
              ...children.props
            })}
          </AbacusControl>
          <AbacusVariant bucket={1}>
            {React.cloneElement(children, {
              ...children.props,
              target: '_blank'
            })}
          </AbacusVariant>
        </AbacusExperiment>
      );
    } else if (deviceInformation && deviceInformation.tablet) {
      return React.cloneElement(children, {
        ...children.props,
        target: '_blank'
      });
    }

    return React.cloneElement(children, {
      ...children.props
    });
  }
);

TargetableLink.displayName = 'TargetableLink';
